import { StateWithUIState } from 'shared/types';

export const uiSelector = {
  getUI: (state: StateWithUIState) => state.ui,
  getProp: (propKey: string) => (state: StateWithUIState) => state.ui[propKey],
};
